import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/nprogress/styles.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import AppContextProvider from "./contexts/AppContext";
import ToastContainer from "./components/ToastContainer";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import RootRedirect from "./pages/RootRedirect";
import Login from "./pages/Login";
import Users from "./pages/Users";
import UserDetails from "./pages/UserDetails";
import AdminKYC from "./pages/AdminKYC";
import LoanRequests from "./pages/LoanRequests";
import LoanRequestDetails from "./pages/LoanRequestDetails";
import LoanProducts from "./pages/LoanProducts";
import Fees from "./pages/Fees";
import Account from "./pages/Account";
import Reports from "./pages/Reports";
import LoanPortfolioReport from "./pages/Reports/LoanPortfolio";
import DisbursementReport from "./pages/Reports/Disbursements";
import RepaymentReport from "./pages/Reports/Repayments";
import RevenueReport from "./pages/Reports/Revenue";
import TransactionReport from "./pages/Reports/Transactions";
import FeeCollectionReport from "./pages/Reports/FeeCollection";
import RiskComplianceReport from "./pages/Reports/RiskCompliance";
import OperationalReport from "./pages/Reports/Operational";
import LoanSchedulingReport from "./pages/Reports/LoanScheduling";
import LoanScheduleDetailPage from "./pages/Reports/LoanScheduling/Detail";
import NotFound from "./pages/NotFound";

import "./index.scss";

const router = createBrowserRouter([
   {
      path: "/",
      element: <RootRedirect />,
   },
   {
      path: "/login",
      element: <Login />,
   },
   {
      path: "/dashboard",
      element: (
         <ProtectedRoute>
            <DashboardLayout />
         </ProtectedRoute>
      ),
      children: [
         {
            index: true,
            element: <Navigate to="/dashboard/users" replace />,
         },
         {
            path: "users",
            element: <Users />,
         },
         {
            path: "users/:userId",
            element: <UserDetails />,
         },
         {
            path: "kyc",
            element: <AdminKYC />,
         },
         {
            path: "loan-products",
            element: <LoanProducts />,
         },
         {
            path: "loan-requests",
            element: <LoanRequests />,
         },
         {
            path: "loan-requests/:requestId",
            element: <LoanRequestDetails />,
         },
         {
            path: "fees",
            element: <Fees />,
         },
         {
            path: "reports",
            element: <Reports />,
         },
         {
            path: "reports/loan-portfolio",
            element: <LoanPortfolioReport />,
         },
         {
            path: "reports/disbursements",
            element: <DisbursementReport />,
         },
         {
            path: "reports/repayments",
            element: <RepaymentReport />,
         },
         {
            path: "reports/revenue",
            element: <RevenueReport />,
         },
         {
            path: "reports/transactions",
            element: <TransactionReport />,
         },
         {
            path: "reports/fee-collection",
            element: <FeeCollectionReport />,
         },
         {
            path: "reports/risk-compliance",
            element: <RiskComplianceReport />,
         },
         {
            path: "reports/operational",
            element: <OperationalReport />,
         },
         {
            path: "reports/loan-scheduling",
            element: <LoanSchedulingReport />,
         },
         {
            path: "reports/loan-scheduling/:loanID",
            element: <LoanScheduleDetailPage />,
         },
         {
            path: "account",
            element: <Account />,
         },
      ],
   },
   {
      path: "*",
      element: <NotFound />,
   },
]);

function App() {
   return (
      <MantineProvider
         theme={{
            primaryColor: "green",
            colors: {
               green: [
                  "#E8F5E9",
                  "#C8E6C9",
                  "#A5D6A7",
                  "#81C784",
                  "#66BB6A",
                  "#699269",
                  "#558B2F",
                  "#33691E",
                  "#1B5E20",
                  "#0D3E1F",
               ],
            },
         }}
      >
         <Notifications />
         <ToastProvider>
            <AuthProvider>
               <AppContextProvider>
                  <RouterProvider router={router} />
               </AppContextProvider>
            </AuthProvider>
            <ToastContainer />
         </ToastProvider>
      </MantineProvider>
   );
}

export default App;
